import React, { useState } from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, PieChart, Pie, Cell,
} from 'recharts';
import {
  Container, Grid, Button, FormGroup, Typography, TextField,
} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt-BR';
import { format } from 'date-fns';
import api from '../../../services/api';
import './styles.css';
import NumberFormat from 'react-number-format';
import Progress from '../../../components/Progress';
import { useStyles } from '../../../components/Styles';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const COLORS = [
  '#003f5c',
  '#2f4b7c',
  '#665191',
  '#a05195',
  '#d45087',
  '#f95d6a',
  '#ff7c43',
  '#ffa600',
];

function OccurrenceReport() {
  const [estimatedData, setEstimatedData] = useState([]);
  const [locale, setLocale] = React.useState('pt');
  const [typeData, setTypeData] = useState([]);
  const [degreeData, setDegreeData] = useState([]);
  const [selectedBeginDate, handleBeginDateChange] = useState(new Date());
  const [selectedEndDate, handleEndDateChange] = useState(new Date());
  const [ploted, handlePloted] = useState(false);
  const classes = useStyles();
  const [openProgress, setOpenProgress] = useState(false);

  const formik = useFormik({
    initialValues: {
      start_time: '',
      end_time: '',
      description: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Campo Obrigatório'),
      cpfCnpj: Yup.string().required('Campo Obrigatório'),
      start_time: Yup.string()
        .test(
          'not empty',
          'Start time cant be empty',
          (value) => !!value,
        )
        .test(
          'start_time_test',
          'Start time must be before end time',
          (value) => isSameOrBefore(value, formik.values.end_time),
        ),
    }),
    onSubmit: (values) => {
      formik.values.start_time = selectedBeginDate;
      formik.values.end_time = selectedEndDate;
    },
  });
  function isSameOrBefore(value, dateEnd) {
    return (value < dateEnd);
  }
  async function plotgraph() {
    setOpenProgress(true);
    handlePloted(true);
    const filter = {
      date_start: new Date(),
      date_end: new Date(),
    };
    let dataset = null;
    await api.get('occurrences/report', { params: { ...filter } });
    return api.request({
      url: 'occurrences/report',
      params: { ...filter },
      method: 'get',
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    })
      .then((response) => {
        alert(JSON.stringify(response));
        if (response.data.length > 0) {
          dataset = response.data
            .map((v) => ({
              ...v,
              first_observation: new Date(v.first_observation).toJSON().slice(0, 10).split('-')
                .join('/'),
              estimated_loss: parseFloat(v.estimated_loss),
            }));
        }
      });
    /* if(dataset){
        const degrees = [...new Set(dataset.map(v => v.degree))].sort((a, b) => a - b)
        const types = [...new Set(dataset.map(v => v.type))].sort((a, b) => a - b)
        const dates = [...new Set(dataset.map(v => v.first_observation))]

        //Degree
        let dados = []
        degrees.forEach((degree) => {
            dados.push({
                name: `Grau ${degree}`,
                value: dataset.filter((d) => d.degree === degree).length*100/dataset.length
            })
        })

        setDegreeData(dados)

        //Type
        dados = []
        types.forEach((type) => {
            dados.push({
                name: type,
                value: dataset.filter((d) => d.type === type).length*100/dataset.length
            })
        })
        setTypeData(dados)

        //Estimated Loss
        dados = []
        dates.forEach((date) => {
            dados.push({
                value: dataset.filter((d) => d.first_observation === date).reduce((count, item) => {
                    count += item.estimated_loss
                    return count
                }, 0),
                date: new Date(date).getTime(),
            })
        })
        setEstimatedData(dates)
        }
        setOpenProgress(false) */
  }

  return (
    <Container className={classes.root}>
      {openProgress ? <Progress /> : null}
      <FormGroup>
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={6} md={4}>
            <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
              <DatePicker
                fullWidth
                InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                label="Data inicial"
                name="begin"
                variant="inline"
                inputVariant="outlined"
                invalidDateMessage="Data Inválida"
                value={selectedBeginDate}
                onChange={(date) => handleBeginDateChange(date)}
                format="dd/MM/yyyy"
                                // inputFormat="DD/MM/YYYY"
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
              <DatePicker
                fullWidth
                InputLabelProps={{ style: { pointerEvents: 'auto' }, shrink: true }}
                label="Data Final"
                name="end"
                variant="inline"
                inputVariant="outlined"
                invalidDateMessage="Data Inválida"
                value={selectedEndDate}
                onChange={(date) => handleEndDateChange(date)}
                format="dd/MM/yyyy"
                                // inputFormat="DD/MM/YYYY"
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Button
              fullWidth
              variant="contained"
              onClick={
                                () => {
                                  formik.handleSubmit();
                                  plotgraph();
                                }
}
              size="large"
            >
              Gerar
            </Button>
          </Grid>
        </Grid>
      </FormGroup>
      <Grid>
        {
                    ploted
                      ? (
                        <Grid container spacing={3} justifyContent="center" alignItems="center">
                          <Grid item xs={12} md={6}>
                            <Typography id="title" variant="h6" align="center">
                              Quantidade de ocorrências por Grau
                            </Typography>
                            <ResponsiveContainer height={300}>
                              <PieChart>
                                <Pie cx="50%" cy="50%" data={degreeData} dataKey={degreeData.valor} nameKey={degreeData.name}>
                                  {
                                                degreeData.map((v, i) => <Cell key={`${v.name}${i}`} fill={COLORS[i % COLORS.length]} />)
                                            }
                                </Pie>
                                <Tooltip formatter={(value) => <NumberFormat value={value} displayType="text" suffix="%" decimalScale={2} />} />
                                <Legend />
                              </PieChart>
                            </ResponsiveContainer>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography id="title" variant="h6" align="center">
                              Quantidade de ocorrências por Tipo
                            </Typography>
                            <ResponsiveContainer height={300}>
                              <PieChart>
                                <Pie data={typeData} dataKey={typeData.valor} nameKey={typeData.name}>
                                  {
                                                typeData.map((v, i) => <Cell key={`${v.name}${i}`} fill={COLORS[i % COLORS.length]} />)
                                            }
                                </Pie>
                                <Tooltip formatter={(value) => <NumberFormat value={value} displayType="text" suffix="%" decimalScale={2} />} />
                                <Legend />
                              </PieChart>
                            </ResponsiveContainer>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography id="title" variant="h6" align="center">
                              Perda estimada (em R$)
                            </Typography>
                            <ResponsiveContainer height={300}>
                              <LineChart>
                                <XAxis
                                  scale="time"
                                  dataKey="date"
                                  type="number"
                                  domain={['auto', 'auto']}
                                  allowDuplicatedCategory={false}
                                  tickFormatter={(tick) => format(new Date(tick), 'dd/MM/yyyy')}
                                />
                                <YAxis dataKey="value" />
                                <Tooltip
                                  labelFormatter={(label) => format(new Date(label), 'dd/MM/yyyy')}
                                  formatter={(value) => <NumberFormat value={value} displayType="text" prefix="R$" fixedDecimalScale decimalSeparator="," decimalScale={2} />}
                                />
                                <Legend />
                                <Line stroke="#003f5c" type="monotone" strokeWidth={2} data={estimatedData} dataKey="value" name="Perda Estimada" />
                              </LineChart>
                            </ResponsiveContainer>
                          </Grid>
                        </Grid>
                      )
                      : <div />
                }
      </Grid>
    </Container>
  );
}

export default OccurrenceReport;
